import { FormField, FormBaseStore } from 'sos-common/js/commonTypes';
import { Dispatch } from 'redux';
import { thunkGetStateFunc } from 'sos-eservice-common/js/Redux';
import { SET_FORM_VALUE, setFormValueAction, setValidationResults } from 'sos-eservice-common/js/Redux/Actions';
import { doValidateByState } from 'sos-eservice-common/js/services';

export function setQualityRegistersValue(field: FormField<any>) {
  return function(dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    if (field.fieldName === 'QualityRegister') {
      dispatch({
        type: SET_FORM_VALUE,
        payload: {
          fieldName: 'OtherQualityRegister',
          value: ''
        }
      } as setFormValueAction);
    }

    dispatch({
      type: SET_FORM_VALUE,
      payload: field
    } as setFormValueAction);

    doValidateByState(getState()).then(validationResults => {
      dispatch(setValidationResults(validationResults));
    });
  };
}
